<template>
    <div class="mingtang hml_whplt">
        <swiperList :swiperStyle="{padding: '2.25rem .4rem .5rem'}">
            <li
            class="mingtangSilde"
            v-for="(item,index) in list"
            :key="index"
            @click="sildeClick(item)"
            >
                <div class="img">
                    <img :src="item.thumb">
                </div>
                
                <div class="textBox">
                    <h2 class="title">{{ item.title }}</h2>
                    <p>{{ item.description }}</p>
                </div>
            </li>
        </swiperList>
        <div class="cover" :style="{zIndex: coverFlag? '10': '-1'}">
            <div class="swiper-container contentSwiper">
                <ul class="swiper-wrapper">
                    <li class="swiper-slide"
                    v-for="(item,index) in list"
                    :key="index"
                    >
                        <div class="content">
                            <img :src="item.thumb">
                            <h2 v-html="item.title.replace(/<br \/>/g,'')">}</h2>
                            <div class="xian">
                                <img src="@/assets/img/secondLevelPage/cradBottom.png">
                            </div>
                            <div class="list">
                                <span v-html="item.keywords"></span>
                            </div>
                            <div class="colse" @click="colseClick">
                                ×
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

import Swiper from "swiper";
import 'swiper/css/swiper.css';
export default {
    data() { 
        return {
            item: {
                title: "",
            },
            coverFlag: false,
        }
    },
    created(){
        this.list.sort((a,b) => {
            return a.food_id - b.food_id;
        })
    },
    mounted(){
        setTimeout(() => {
            this.swiper = new Swiper('.contentSwiper',{});
            console.log(this.swiper);
        },200)
    },
    methods: {
        sildeClick(item){
            // this.$emit("sildeClick",item)
            this.item = item;
            this.coverFlag = true;
            let index = 0;
            for(let i = 0; i < this.list.length; i++){
                if(this.list[i].title == item.title){
                    index = i;
                }
            }
            this.swiper.slideTo(index,300,false);
        },
        colseClick(){
            this.coverFlag = false;
        },
    },
    props: {
        list: {
            type: Array
        }
    }
}
</script>

<style lang="scss" scoped>
.mingtang{
    padding-top: 2.25rem;
    .mingtangSilde{
        width: 6.7rem;
        height: 2.3rem;
        display: flex;
        align-items: center;
        padding: .2rem 0;
        box-shadow:0px .04rem .1rem 0px rgba(41,41,41,0.2);
        border-radius: .1rem;
        margin-bottom: .32rem;
        background: #fff;
        .img{
            width: 3rem;
            height: 1.92rem; 
            img{
                width: 3rem;
                height: 1.92rem;
            }
        }
        .textBox{
            width: 3.7rem;
            // display: flex;
            // flex-direction: column;
            // justify-content: flex-end;
            height: 1.92rem;
            margin-left: .1rem;
            position: relative;
            .title{
                width: 1.98rem;
                height: .68rem;
                background:linear-gradient(0deg,rgba(65,192,162,1) 0%,rgba(15,164,130,1) 100%);
                border-bottom-left-radius: .5rem;
                font-size: .32rem;
                color: #fff;
                position: absolute;
                right: 0;
                top: 0;
                text-indent: .62rem;
                line-height: .68rem;
                font-family: "siyuan";
                font-weight: bold;
            }
            p{
                font-size: .22rem;
                color: #666;
                margin-top: .8rem;
                padding-right: .3rem;
                line-height: .36rem;
            }
        }
    }
    .cover{
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        overflow: hidden;
        background: rgba(0,0,0,.5);
        z-index: -1;
        .contentSwiper{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            // transform: translate(-50%,-50%);
            // overflow: initial;
            .colse{
                width: .72rem;
                height: .72rem;
                border: .04rem solid #eee;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: -1.46rem;
                border-radius: 50%;
                color: #eee;
                font-size: .5rem;
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: .7;
            }
            li{
                width: 100%;
                height: 100%;
                position: relative;
                .content{
                    width: 6rem;
                    height: 8rem;
                    background: #fff;
                    border-radius: .1rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding-top: .78rem;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%,-50%);
                        img{
                            width: 5.7rem;
                            height: 3.65rem;
                        }
                        h2{
                            font-size: .68rem;
                            color: #333;
                            font-family: "siyuan";
                            margin-top: .92rem;
                        }
                        .xian{
                           width: 2.14rem;
                           height: .08rem;
                           margin: .26rem 0.22rem;
                           img{
                               width: 100%;
                               height: 100%;
                           } 
                        }
                        .list{
                            display: flex;
                            span{
                                color: #999;
                                font-size: .36rem;
                            }
                        }
                    }
                }
                
        }
        .content{
            
        }
    }
}
</style>